import { FormInput } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const SectorUnitFields = memo(() => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="sectorBasicUnitExternalIdThen"
          fullWidth
          label={t(translationPath + "sector_basic_unit_external_id_then")}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="sectorComplUnitExternalIdThen"
          fullWidth
          label={t(translationPath + "sector_compl_unit_external_id_then")}
        />
      </Grid>
    </>
  );
});
